<template>
  <div>
    <el-form
      size="small"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="110px"
    >
      <el-form-item label="提示语" prop="hint">
        <el-input
          style="width:350px"
          v-model="form.hint"
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
      <!-- 时间初始值 -->
      <el-form-item label="时间初始值" prop="timeConfig">
        <el-input-number
          style="width:200px"
          v-model="form.defaultValue"
          :max="form.bounds.max"
          :min="form.bounds.min"
        ></el-input-number>
        <span class="marginL10">秒</span>
        <el-link type="primary" class="marginL20" @click="handleScopeTime"
          >取值范围</el-link
        >
      </el-form-item>
      <!-- 设置类型 -->
      <el-form-item label="设置类型">
        <el-select size="small" class="btnConfigInput" v-model="form.customer">
          <el-option :value="true" label="终端用户可以更改时间"></el-option>
          <el-option :value="false" label="时间不可更改"></el-option>
        </el-select>
      </el-form-item>
      <!-- 计时方式 -->
      <el-form-item label="计时方式">
        <el-select
          size="small"
          class="btnConfigInput"
          v-model="form.timingMethod"
        >
          <el-option :value="1" label="正计时"></el-option>
          <el-option :value="2" label="倒计时"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="属性">
        <el-select
          v-model="form.propertyId"
          class="btnConfigInput"
          size="small"
        >
          <el-option
            v-for="type in propertes"
            :key="type.id"
            :value="type.id"
            :label="type.propertyName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="addContent" type="danger" plain
          >说明内容配置</el-button
        >
      </el-form-item>
    </el-form>
    <TimeRanger
      :row="ranger"
      @set="setTime"
      v-if="visible"
      :visible.sync="visible"
    />
    <ContentEdit
      @set="setContent"
      :propertes="propertes"
      v-if="contentVisible"
      :visible.sync="contentVisible"
      :content="content"
    />
  </div>
</template>

<script>
import TimeRanger from "./TimeRanger";
import ContentEdit from "./ContentEdit";
export default {
  props: ["propertes", "pages", "row"],
  components: {
    TimeRanger,
    ContentEdit
  },
  data() {
    return {
      visible: false,
      contentVisible: false,
      rules: {},
      ranger: {},
      content: {},
      form: {
        hint: "",
        propertyId: "",
        bounds: {},
        floatContents: []
      }
    };
  },
  created() {
    if (this.row) {
      this.form = {
        hint: this.row.hint,
        floatContents: this.row.floatContents,
        ...this.row.timeConfig,
        bounds: JSON.parse(this.row.timeConfig.bounds)
      };
    }
  },
  methods: {
    handleScopeTime() {
      this.visible = true;
      this.ranger = { ...this.form.bounds };
    },
    setTime(bounds) {
      this.form.bounds = bounds;
    },
    addContent() {
      this.contentVisible = true;
      this.content = this.$utils.deepClone(this.form.floatContents);
    },
    setContent(content) {
      this.form.floatContents = content;
      console.log(content);
    },
    handleSubmit() {
      return {
        hint: this.form.hint,
        floatContents: this.form.floatContents,
        timeConfig: {
          defaultValue: this.form.defaultValue,
          propertyId: this.form.propertyId,
          customer: this.form.customer,
          timingMethod: this.form.timingMethod,
          bounds: JSON.stringify(this.form.bounds)
        }
      };
    }
  }
};
</script>

<style></style>
